<template>
  <div class="login-container">
    <!-- Cabecera para el logo -->
    <header class="login-header">
        <div class="logo-container">
          <img :src="logoOptimiza" class="navbar-brand-img h-100" alt="main_logo" />
        </div>
        <div class="analiza-container">
          <img :src="logoAnaliza" class="navbar-analiza-img h-100" alt="sec_logo" />
        </div>
    </header>

    <!-- Cuerpo con imagen de fondo y formulario centrado -->
    <main class="login-body" :style="{ backgroundImage: 'url(' + require('@/assets/img/bg-home.png') + ')' }">
      <div class="login-content">
        <div>
          <h3 class="text-cabecera-login">
            <span>Optimiza</span>tu farmacia
          </h3>
        </div>

        <div class="form-overlay">
          <div class="card zona-login">
            <div class="pt-0 pb-0 card-header text-left">
              <p class="cab-login mb-0" v-if="!modoRecuperacion">Indica tus credenciales de acceso:</p>
              <p class="cab-login mb-0" v-if="modoRecuperacion">Indica tu usuario o NIF para recuperar tu clave:</p>
            </div>
            <div class="zona-error" v-if="textoError">
              <p class="text-danger m-0"><i class="fas fa-circle-exclamation text-danger mx-2"></i> {{ textoError }}</p>
            </div>
            <div class="card-body pb-3">
              <Form
                role="form"
                class="text-start"
                :validation-schema="schema"
                @submit="handleLogin"
              >
                <soft-field
                  id="usuario"
                  v-model="user.usuario"
                  type="text"
                  placeholder="Indique su usuario o NIF"
                  name="usuario"
                  class="mb-3"
                />

                <soft-field
                  id="password"
                  v-model="user.password"
                  type="password"
                  placeholder="Indique su clave"
                  name="password"
                  class="mb-3"
                  v-if="!modoRecuperacion"
                />

                <div class="text-center">
                  <soft-button
                    class="my-2 mt-0 mb-0 text-sm"
                    color="analiza-azul"
                    full-width
                    :is-disabled="loading ? true : false"
                  >
                    <span
                      v-if="loading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                    <span v-else-if="!modoRecuperacion">Acceder</span>
                    <span v-else>Recuperar</span>
                  </soft-button>
                </div>
              </Form>
            </div>

            <div class="px-1 pt-0 pb-0 text-center card-footer px-lg-2">
              <p class="mx-auto mb-0 text-sm" v-if="!modoRecuperacion">
                ¿Olvidaste tu clave?
                <span @click="modoRecuperacion=true" style="text-decoration:underline;cursor:pointer;">
                  Recupérala
                </span>
              </p>
              <p class="mx-auto mb-0 text-sm" v-if="modoRecuperacion">
                ¿Recordaste tu clave?
                <span @click="modoRecuperacion=false" style="text-decoration:underline;cursor:pointer;">
                  Accede a tu cuenta
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Pie para el aviso legal -->
    <div class="login-footer">
      <div class="footer-top" :style="{ backgroundImage: 'url(' + require('@/assets/img/parentesis.svg') + ')' }">
        <img :src="iconoAnaliza" class="navbar-login-img h-100" alt="sec_icon" />
        <p>La <span class="azul-cursivo">farmacia</span> es presente,<br/>pero también futuro</p>
        <div>Hagámosla crecer <span class="azul-cursivo">juntos</span></div>
        <a href="https://analiza360.es/contacto/"><span>Contacta</span></a>
      </div>
      <div class="footer-bottom">
        <a href="https://analiza360.es/wp-content/uploads/2026/03/Analiza360Cliente.exe"><span>Soporte</span></a>
        <a href="https://analiza360.es/aviso-legal/"><span>Aviso Legal</span></a>
        <a href="https://analiza360.es/politica-de-privacidad/"><span>Política de privacidad</span></a>
      </div>
    </div>
  </div>
</template>

<script>
import SoftField from "@/components/SoftField.vue";
import SoftButton from "@/components/SoftButton.vue";
import showSwal from "/src/mixins/showSwal.js";
import { mapMutations } from "vuex";
import { Form } from "vee-validate";
import * as yup from "yup";
import logoOptimiza from "@/assets/img/logo-optimiza-azul.png";
import logoAnaliza from "@/assets/img/logo-analiza-azul.png";
import iconoAnaliza from "@/assets/img/icon-analiza-verde.png";


export default {
  name: "Login",
  components: {
    SoftField,
    SoftButton,
    Form,
  },

  computed: {
    schema() {
      const rules = {
        usuario: yup.string().required("Debe indicar su usuario o NIF!"),
      };
      if (!this.modoRecuperacion) {
        rules.password = yup.string().required("Debe indicar su clave!");
      }
      return yup.object().shape(rules);
    },
  },

  data() {
    const user = {
      usuario: "",
      password: "",
    };
    return {
      loading: false,
      modoRecuperacion: false,
      user,
      logoOptimiza,
      logoAnaliza,
      iconoAnaliza,
      textoError: ''
    };
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  async beforeMount() { 
    this.$store.state.showSidenav = false;
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    async handleLogin() {
      this.loading = true;
      try {
        if (this.modoRecuperacion) {
          await this.$store.dispatch("auth/recoverPassword", this.user);

          showSwal.methods.showSwal({
            type: "success",
            message: "Si el usuario existe, se ha enviado un email con las instrucciones para recuperar tu clave",
          });

          this.modoRecuperacion = false;
          this.loading = false;
          this.textoError = '';
        } else {
          await this.$store.dispatch("auth/login", this.user);
          this.$router.push("/home");
        }
      } 
      catch (error) {  console.error("Error en el proceso de autenticación:", error);
        this.textoError = this.modoRecuperacion ? "Error al recuperar la contraseña" : "Datos de acceso erróneos";
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.login-header {
  flex-shrink: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.98);
  height: 72px;
  padding: 10px 0;
  box-shadow: 0 9px 20px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 2;
}

.logo-container {
  height: 100%;
  padding: 7px 20px;
  display: inline-block;
  width: 50%;
  text-align: left;
  vertical-align: top;
}

.analiza-container {
  height: 100%;
  padding: 15px 20px;
  display: inline-block;
  width: 50%;
  text-align: right;
}

.logo-text {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.login-content {
  flex: 1;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 60px 0;
  min-height: calc(100vh - 90px);
  background-image: linear-gradient(130deg, #ffffff80 60%, #FFFFFF00 80%);
  gap: 20px;
}

.form-overlay {
  background-color: rgba(255, 255, 255, 1);
  padding: 30px;
  border-radius: 25px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  margin-top: 30px;
}

.zona-login {
  background-color: white !important;
  border: none;
  box-shadow: none;
  p.cab-login {
    font-weight: 600;
    text-transform: uppercase;
    color: var(--bs-analiza-dark);
  }
  :deep(input[type="text"]), :deep(input[type="password"]) {
    background-color: #e2eff0;
    border-radius: 10px !important;
    padding: 7px 20px !important;
    font-size: 16px !important;
    border: 0;
  }
}

.login-footer {
  background-color: var(--bs-analiza-dark);
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  padding: 10px;
  font-size: 0.8em;
  color: white;
}

.legal-notice {
  margin: 0;
}

h3.text-cabecera-login {
  font-family: "Montserrat", Sans-serif;
  font-size: 72px;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1em;
  color: var(--bs-analiza-light);
  margin: 0;
  text-align: center;
  span{
    font-weight: 300 !important;
    color: var(--bs-analiza-dark) !important;
    font-size: 45px !important;
    display:block;
  }
} 

.footer-top {
  display:block;
  width:100%;
  max-width:500px;
  margin:0 auto;
  background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 70px;
  img {width:90px;margin:30px auto;display:block;}
  p {
    font-family: "Montserrat", Sans-serif;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.4em;
    color: white;
    text-align:center;
    margin-bottom: 10px;
  }
  div {
    font-family: montserrat;
    font-size:18px;
    line-height:1.4em;
    text-align:center;
  }
  .azul-cursivo {
    font-style: italic;
    color: var(--bs-analiza-light) !important;
  }
  a {
    background-color: var(--bs-analiza-light);
    font-family: "Montserrat", Sans-serif;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1.3em;
    fill: var(--e-global-color-primary);
    color: var(--bs-analiza-dark);
    transition-duration: 0.5s;
    padding: 14px 20px 14px 20px;
        display: block;
    width: 132px;
    border-radius: 24px;
    margin: 20px auto;
    &:hover {
      background-color:white;
    }
  }
}
.footer-bottom {
  text-align: center;
  margin-top: 20px;
  a {
    color: white;
    font-family: montserrat;
    font-size: 13px;
    padding: 5px 10px;
  }
}

.navbar-brand-img, .navbar-analiza-img {
  vertical-align:top;
}

@media (max-width: 1250px) {
  h3.text-cabecera-login {
    font-size: 65px;
    span {
      font-size: 32px !important;
    }
  }
}

@media (max-width: 800px) {
  h3.text-cabecera-login {
    font-size:58px;
    span {
      font-size: 28px !important;
    }
  }
  .login-header {
    height: 65px;
  }
  .analiza-container {
    padding:13px 20px;
  }
}

@media (max-width: 500px) {
  h3.text-cabecera-login {
    font-size:44px;
    span {
      font-size: 25px !important;
    }
  }
  .login-header {
    height: 58px;
  }
  .form-overlay {
    padding: 20px;
    max-width:92%;
    margin-top: 20px;
  }
  .logo-container {
    padding: 5px 10px;
  }
  .analiza-container {
    padding:12px 10px;
  }
}
</style>
